import React from "react";
import { useGetOfmSchedulerJobsQuery } from "@/services/ofm-extract";
import OfmJobsTable from "components/ofm-jobs-table";
import { PropsSchedulerJob } from "../../dtos/ofm-dtos";
import { computePollingInterval, isTerminal, OfmJobStatus } from "../../utils/ofm.job.status";

export default function SchedulerJobs({ schedulerId, codInvoiceModel }: PropsSchedulerJob) {
  const { data, isFetching, refetch } = useGetOfmSchedulerJobsQuery(
    { schedulerId },
    {
      refetchOnFocus: true,
      refetchOnReconnect: true,
      selectFromResult: (res) => {
        const items = res.data?.items ?? [];
        const allDone = items.length > 0 && items.every(j => isTerminal(j.status as OfmJobStatus));
        return { ...res, allDone };
      },
    }
  );

  const rows = data?.items ?? [];
  const intervalMs = React.useMemo(() => computePollingInterval(rows as any), [rows]);
  useGetOfmSchedulerJobsQuery(
    { schedulerId },
    {
      refetchOnFocus: true,
      refetchOnReconnect: true,
      pollingInterval: intervalMs ?? 0,
      skip: intervalMs === null,
    }
  );


  React.useEffect(() => {
    if (!intervalMs) return;
    const id = setInterval(() => refetch(), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs, refetch]);

  return <OfmJobsTable rows={rows} isLoading={isFetching} codInvoiceModel={codInvoiceModel} />;
}
